<template>
    <div class="rr-checkout__step rr-checkout__step_summary" v-show="active">
        <div uk-grid>
            <div class="uk-width-1-1 uk-text-center uk-text-left@m">
                <p class="uk-h3">{{ $t('rubinred.ecommerce.orders.checkout.step-4.title') }}</p>
            </div>
            <div class="uk-width-1-1">
                <div class="rr-checkout__recap uk-grid-divider" uk-grid v-if="summary">
                    <div class="uk-width-1-2@s" v-if="summary.shipping && summary.shipping.method">
                        <div class="rr-checkout__recap-wrapper">
                            <div class="rr-checkout__recap-header">
                                <p class="rr-checkout__recap-header-title">
                                    {{ $t('rubinred.ecommerce.orders.checkout.step-4.box_3_title') }}
                                </p>
                                <a @click="goToStep(!customer ? 2 : 1)">
                                    {{ $t('frontend-action.edit') }}
                                </a>
                            </div>
                            <div class="rr-checkout__recap-body">
                                <ul class="uk-list">
                                    <li>{{ summary.shipping.method.name }}</li>
                                </ul>
                            </div>
                        </div>
                        <div class="rr-checkout__recap-wrapper">
                            <slot
                                :name="summary.shipping.method.slug"
                                :data="summary.shipping">
                            </slot>
                        </div>
                        <div class="rr-checkout__recap-wrapper" v-if="cart.notes">
                            <div class="rr-checkout__recap-header">
                                <p class="rr-checkout__recap-header-title">
                                    {{ $t('rubinred.ecommerce.orders.checkout.notes') }}
                                </p>
                            </div>
                            <div class="rr-checkout__recap-body">
                                {{ cart.notes }}
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-2@s" v-if="summary.payment && summary.payment.method">
                        <div class="rr-checkout__recap-wrapper">
                            <div class="rr-checkout__recap-header">
                                <p class="rr-checkout__recap-header-title">
                                    {{ $t('rubinred.ecommerce.orders.checkout.step-4.box_4_title') }}
                                </p>
                                <a @click="goToStep(!customer ? 3 : 2)">
                                    {{ $t('frontend-action.edit') }}
                                </a>
                            </div>
                            <div class="rr-checkout__recap-body">
                                <ul class="uk-list">
                                    <li>{{ summary.payment.method.name }}</li>
                                </ul>
                                <component v-if="summary.payment.method.handler" :is="summary.payment.method.handler + 'Summary'"></component>
                            </div>
                        </div>
                        <div class="rr-checkout__recap-wrapper" v-if="summary.payment.billing">
                            <div class="rr-checkout__recap-header">
                                <p class="rr-checkout__recap-header-title">{{
                                    $t('rubinred.ecommerce.orders.checkout.step-4.box_2_title') }}</p>
                                <a @click="goToStep(!customer ? 3 : 2)">{{
                                    $t('frontend-action.edit') }}</a>
                            </div>
                            <div class="rr-checkout__recap-body">
                                <ul class="uk-list">
                                    <li>{{ summary.payment.billing.first_name }} {{ summary.payment.billing.last_name
                                        }}
                                    </li>
                                    <li>{{ summary.payment.billing.street }}</li>
                                    <li>{{ summary.payment.billing.postcode }} {{ summary.payment.billing.city }}</li>
                                    <li>{{ summary.payment.billing.present.region }} {{
                                        summary.payment.billing.present.country }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="rr-checkout__wrapper uk-margin-large-top">
                    <div class="rr-checkout__content">
                        <div class="rr-checkout__content-wrapper">
                            <div class="rr-checkout__recap-wrapper">
                                <div class="rr-checkout__recap-header">
                                    <p class="rr-checkout__recap-header-title">
                                        {{ $t('rubinred.ecommerce.orders.checkout.step-4.box_5_title') }}
                                    </p>
                                </div>
                                <div class="rr-checkout__recap-body">
                                    <table class="rr-checkout-table uk-table uk-table-divider uk-table-responsive">
                                        <tbody>
                                            <tr v-for="item in cart.items" :key="item.id">
                                                <td class="rr-checkout-table__image">
                                                    <figure>
                                                        <span v-if="item.thumbnail" v-html="item.thumbnail"></span>
                                                    </figure>
                                                </td>
                                                <td>
                                                    <div class="rr-checkout-table__body">
                                                        <p class="rr-checkout-table__title">{{ item.name }}</p>
                                                        <p class="rr-checkout-table__text"><strong>Cod:</strong>#{{ item.code }}</p>
                                                        <p class="rr-checkout-table__options">
                                                            <span v-for="(key, value) in item.options">
                                                                <strong>{{ key }}:</strong> {{ value }}
                                                            </span>
                                                        </p>
                                                        <p class="rr-checkout-table__gift" v-if="item.gift">
                                                            {{ $t('rubinred.ecommerce.orders.common.is_gift') }}
                                                        </p>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="rr-checkout-table__quantity">
                                                        {{ $t('rubinred.ecommerce.orders.common.quantity') }}: {{ item.quantity }}
                                                    </div>
                                                </td>
                                                <td class="rr-checkout-table__price uk-text-right@m">
                                                    <div class="rr-checkout-table__price-reduced">
                                                        <del v-if="item.pricing.reduced" v-html="Utils.Currencies.toHuman(item.pricing.original_price)"></del>
                                                        <span v-if="item.pricing.reduced">
                                                            - {{ item.pricing.percentage }}%
                                                        </span>
                                                    </div>
                                                    <div class="rr-checkout-table__price-unit">
                                                        {{ Utils.Currencies.toHuman(item.pricing.price) }}
                                                    </div>
                                                    <div class="rr-checkout-table__price-total">
                                                        {{ Utils.Currencies.toHuman(item.total) }}
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="uk-margin-large-top" uk-grid >
                    <div class="uk-width-1-2@m">
                        <div class="uk-alert uk-alert-info">
                            <i class="fal fa-truck"></i>
                            {{$t('rubinred.ecommerce.orders.checkout.step-4.delivery_alert')}}
                        </div>
                    </div>
                    <div class="uk-width-1-2@m">
                        <div class="uk-child-width-1-1" uk-grid>
                            <div>
                                <div class="rr-shopping-cart-resume">
                                    <ul class="rr-shopping-cart-resume__totals-list uk-list">
                                        <li>
                                            <div class="uk-flex uk-flex-middle uk-flex-between">
                                                <span>{{ $t('rubinred.ecommerce.orders.common.subtotal') }}</span>
                                                <strong>{{ Utils.Currencies.toHuman(cart.subtotal) }}</strong>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="uk-flex uk-flex-middle uk-flex-between">
                                                <span>{{ $t('rubinred.ecommerce.orders.common.shipping') }}</span>
                                                <strong>{{ Utils.Currencies.toHuman(cart.shipping_total) }}</strong>
                                            </div>
                                        </li>
                                        <li v-if="cart.payment_total > 0">
                                            <div class="uk-flex uk-flex-middle uk-flex-between">
                                                <span>{{ $t('rubinred.ecommerce.orders.common.payment') }}</span>
                                                <strong>{{ Utils.Currencies.toHuman(cart.payment_total) }}</strong>
                                            </div>
                                        </li>
                                        <li v-if="cart.discount_total < 0">
                                            <div class="uk-flex uk-flex-middle uk-flex-between">
                                                <span>{{ $t('rubinred.ecommerce.orders.common.discount') }}</span>
                                                <strong>{{ Utils.Currencies.toHuman(cart.discount_total) }}</strong>
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="rr-shopping-cart-resume__total uk-flex uk-flex-middle uk-flex-between">
                                        <strong>{{ $t('rubinred.ecommerce.orders.common.order_total') }}</strong>
                                        <strong>{{ Utils.Currencies.toHuman(cart.total) }}</strong>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <button @click="submit" type="submit" class="uk-button uk-button-large uk-button-primary uk-width-1-1">
                                    {{$t('rubinred.ecommerce.orders.checkout.step-4.confirm_cta')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import CartAwareComponent from 'rubinred/ecommerce/js/mixins/CartAwareComponent'
  import CheckoutStep from 'rubinred/ecommerce/js/mixins/CheckoutStep'

  export default {
    mixins: [CartAwareComponent, CheckoutStep],
    props: {
      customer: {
        type: Boolean,
        required: true,
      },
    },
    computed: {
      summary() {
        return this.$store.state.checkout;
      },
    },
    methods: {
      submit() {
        return window.App.Axios.post(this.endpoint).then(response => {
          if (response.data.success) {
            window.location.href = response.data.uri;
          }

          return response;
        });
      },
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/checkout/steps/RubinredCheckoutSummaryStep.vue